<template>
  <div class="-top" v-clickoutside="handleClose">
    <input class="input-" title="选择一个节点" readonly="readonly" placeholder="请选择"
           :value="value._label" @click="handleClick" />
    <transition name="el-zoom-in-top">
      <div class="rel" v-if="showTree">
        <d-tree class="the-tree"
                  :maxDepth="maxDepth"
                  :showPopBox="true"
                  :canChoose="canChoose"
                  @selected="onSelected"
                  :update="{render: () => updateRender}" />
      </div>
    </transition>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import DTree from '../d-tree'

export default {
  components: {
    DTree
  },
  directives: {Clickoutside},
  name: 'input-device-tree',
  props: {
    maxDepth: Number,
    fetch: Function,
    label: String,
    canChoose: {
      type: Boolean,
      default: true
    },
    defaultValue: {}
  },
  data () {
    return {
      showTree: false,
      value: {
        _label: this.label
      },
      updateRender: this.fetch().then(this.onDataLoaded)
    }
  },
  watch: {
    defaultValue (val) {
      this.updateRender = this.fetch().then(this.onDataLoaded)
    }
  },
  methods: {
    handleClick () {
      this.showTree = !this.showTree
    },
    handleClose () {
      this.showTree = false
    },
    onDataLoaded (list) {
      const current = list.find(data => data._value === this.defaultValue) ||
        list.find(data => data._label === this.label)
      if (current) {
        this.value = current
        this.$emit('input', current)
      }
      return list
    },
    onSelected (value) {
      this.value = value
      this.handleClose()
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../common/styles/fun_var";

  .-top {
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

    display: inline-block;
    border: 1px solid #dcdfe6;

    &:hover {
      border-color: #c0c4cc
    }
  }

  .input- {
    width: 100%;
    height: 100%;
    outline: none;
    cursor: pointer;
    padding: 0 15px;
    font-size: inherit;
    border-radius: 999px;
    border: 1px solid transparent;
    &::-webkit-input-placeholder {
      color: #c0c0c0
    }
  }

  .rel {
    z-index: 20180129;
  }

  .the-tree {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    height: 260px!important;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    overflow: hidden;

    background-color: #fff;
    width: 101%;
    margin-top: 14px;
    margin-bottom: 5px;
    left: -1px;
    padding-top: 5px;
    position: absolute;
    z-index: 20180130;
    overflow-x: auto;

    .generate-scrollbar();
  }
</style>



// WEBPACK FOOTER //
// src/components/common/inputs/input-device-tree.vue